const ca_upf = {
  LOAN_ANALYSING:
    "La teva sol·lictiud ha estat processada. Et contactarem un cop s'hagi analitzat. Estigues atent@!",
};
export default ca_upf;
